import React from 'react';
import { SelectInput } from 'react-admin';

import { MapperType } from '../../entities/MapperType';
import { SelectEnumInput } from './SelectEnumInput';

export const MapperTypeSelect = (props) => (
	<SelectEnumInput
		key={"mapper_type"} 
		resettable 
		enumName="mapper-type" 
		enumObj={props.enumObj ? props.enumObj : MapperType } 
		style={{minWidth: "240px"}} 
		{...props}/>
);
